module.exports = __webpack_public_path__ + "static/img/14.a94d0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotKeywordsMap/map/14.png
// module id = C21F
// module chunks = 2